import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {AgendaEventAutoGeneratedLabelModel} from "../agendaEventAutoGeneratedLabel.model";

export class AgendaEventAutoGeneratedLabelConverter extends HttpModelConverter<AgendaEventAutoGeneratedLabelModel> {
    protected createInstance(): AgendaEventAutoGeneratedLabelModel {
        return new AgendaEventAutoGeneratedLabelModel();
    }

    protected enrichObject(result: AgendaEventAutoGeneratedLabelModel, src: AgendaEventAutoGeneratedLabelModel) {
    }

}